import { getFilteredIdsBasedOnSearchBox } from "./Actions/Search/getFilteredIdsBasedOnSearchBox";
import { getFilteredIdsBasedOnPrecisionSearch } from "./Actions/Search/getFilteredIdsBasedOnPrecisionSearch";
import { getFilteredIdsBasedOnCheckboxes } from "./Actions/FilterGroups/getFilteredIdsBasedOnCheckboxes";
import { getFilteredData } from "./Actions/Data/getFilteredData";

import { rawData } from "../rawData";
import settings from "../config.json";

const { dataSettings, paginatorSettings } = settings;
const { uid } = dataSettings;

const { defaultNumResultsPerPage } = paginatorSettings;

// Get search string from URL

// // Define helper
const destructureQueryParams = (queryString) => {
  let numParamsFound = 0;

  const queryParams = new URLSearchParams(queryString);
  const queryObject = {};
  for (const [key, value] of queryParams) {
    numParamsFound += 1;

    queryObject[key] = value;
  }

  return { queryObject, numParamsFound };
};

// // Begin program to get search string from URL

const queryString = window.location.search;

// // Destructure QueryString
const { queryObject, numParamsFound } = destructureQueryParams(queryString);

// // Destructure QueryObject
const { search, cartItems, endorsedVariables } = queryObject;

if (endorsedVariables) {
  const arryOfDois = endorsedVariables.split(",");
  // parse list of cartItems

  // translate list of DOI's to list of ID's in rawData
  const arrayOfIds = rawData
    .filter((d) => arryOfDois.includes(d["doi"]))
    .map((d) => d[uid]);

  for (const datum of rawData) {
    if (arrayOfIds.includes(datum[uid])) {
      datum["unsurfaced"] = "surfaced";
    } else {
      datum["unsurfaced"] = "unsurfaced";
    }
  }
}

const { categoricalColumns } = settings;

const initialState = {
  pageNumber: 1,
  selectedCheckboxes: [],

  filteredIdsBasedOnCheckboxes: rawData.map((d) => d[uid]),
  filteredData: rawData,
  advancedSearchOn: false,
  searchString: "",
  precisionSearchQueries: {},

  filteredIdsBasedOnSearchBox: rawData.map((d) => d[uid]),
  filteredIdsBasedOnPrecisionSearch: rawData.map((d) => d[uid]),
  idsOfFilteredData: rawData.map((d) => d[uid]),
  idsOfItemsInStagingArea: [],
  idsOfItemsInCart: [],
  numResultsPerPage: defaultNumResultsPerPage,
  cartCreated: false,
  queryObject,
  numParamsFound,
  includeUnsurfacedVariables: false,
  unfilteredData: rawData.filter((d) => d.unsurfaced !== "unsurfaced"),

  snackbarMessage: "",
  snackbarOpen: false,

  showIncludeEndorsedVariablesToggle: false,
};

if (search) {
  initialState["searchString"] = search;
}

if (endorsedVariables) {
  initialState["showIncludeEndorsedVariablesToggle"] = true;
}

if (cartItems) {
  const arryOfDois = cartItems.split(",");
  // parse list of cartItems

  // translate list of DOI's to list of ID's in rawData
  const arrayOfIds = rawData
    .filter((d) => arryOfDois.includes(d["doi"]))
    .map((d) => d["uid"]);
  initialState["idsOfItemsInCart"] = arrayOfIds;
}

const validCategories = categoricalColumns.map((d) => d.categoricalColumn);

const selectedCheckboxesFromQueryString = [];
for (const objKey of Object.keys(queryObject)) {
  if ((objKey !== "search") & validCategories.includes(objKey)) {
    const newObject = {};
    newObject["categoricalColumn"] = objKey;
    newObject["category"] = queryObject[objKey];
    selectedCheckboxesFromQueryString.push(newObject);
  }
}

if (selectedCheckboxesFromQueryString.length > 0) {
  initialState.selectedCheckboxes = selectedCheckboxesFromQueryString;
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "TOGGLE_INCLUDE_UNSURFACED_VARIABLES_SWITCH":
      const includeUnsurfacedVariables = !state.includeUnsurfacedVariables;
      let unfilteredData = rawData;
      if (!includeUnsurfacedVariables) {
        unfilteredData = rawData.filter((d) => d.unsurfaced !== "unsurfaced");
      }

      return {
        ...state,
        includeUnsurfacedVariables,
        unfilteredData,
      };
    case "SET_PAGE_NUMBER":
      return { ...state, pageNumber: action.payload };

    case "UPDATE_FILTERED_IDS_BASED_ON_CHECKBOX":
      return {
        ...state,
        filteredIdsBasedOnCheckboxes: getFilteredIdsBasedOnCheckboxes(
          state.unfilteredData,
          state.selectedCheckboxes
        ),
      };

    case "UPDATE_FILTERED_DATA":
      const { idsOfFilteredData, filteredData } = getFilteredData(
        state.unfilteredData,
        state.filteredIdsBasedOnSearchBox,
        state.filteredIdsBasedOnCheckboxes,
        state.filteredIdsBasedOnPrecisionSearch,
        state.advancedSearchOn,
        state.viewCartModeOn,
        state.idsOfItemsInCart
      );
      return {
        ...state,
        idsOfFilteredData,
        filteredData,
      };

    case "HANDLE_STAGING_CHECKBOX_CLICK":
      const idOfStagingCheckbox = action.payload;

      // Check to see if we should add or remove the toggled checkbox.
      // We will remove the checkbox if it already exists in idsOfItemsInStagingArea.

      const matchingItems = state.idsOfItemsInStagingArea.filter(
        (id) => id === idOfStagingCheckbox
      );

      const shouldRemoveFromStaging = matchingItems.length > 0;

      const shouldAddToStaging = !shouldRemoveFromStaging;

      if (shouldAddToStaging) {
        return {
          ...state,
          idsOfItemsInStagingArea: [
            ...state.idsOfItemsInStagingArea,
            action.payload,
          ],
        };
      } else {
        return {
          ...state,
          idsOfItemsInStagingArea: state.idsOfItemsInStagingArea.filter(
            (id) => id !== idOfStagingCheckbox
          ),
        };
      }

    case "HANDLE_TOGGLE_CHECKBOX":
      const { nameOfCategoricalColumn, category } = action.payload;

      // Check to see if we should add or remove the toggled checkbox.
      // We will remove the checkbox if it already exists in selectedCheckboxes.

      const shouldRemove = !!state.selectedCheckboxes.find(
        (checkbox) =>
          checkbox["nameOfCategoricalColumn"] === nameOfCategoricalColumn &&
          checkbox["category"] === category
      );
      const shouldAdd = !shouldRemove;

      if (shouldAdd) {
        return {
          ...state,
          selectedCheckboxes: [...state.selectedCheckboxes, action.payload],
        };
      } else {
        const newSelectedCheckboxes = [];
        for (const checkbox of state.selectedCheckboxes) {
          if (
            checkbox["nameOfCategoricalColumn"] !== nameOfCategoricalColumn ||
            checkbox["category"] !== category
          ) {
            newSelectedCheckboxes.push(checkbox);
          }
        }
        return { ...state, selectedCheckboxes: newSelectedCheckboxes };
      }

    case "SET_ADVANCED_SEARCH_ON":
      return { ...state, advancedSearchOn: action.payload };

    case "HANDLE_SEARCH_BOX_CHANGE":
      return { ...state, searchString: action.payload };

    case "HANDLE_PRECISION_SEARCH_BOX_CHANGE":
      const newPrecisionSearchQueries = { ...state.precisionSearchQueries };
      newPrecisionSearchQueries[action.payload.fieldName] =
        action.payload.value;
      return { ...state, precisionSearchQueries: newPrecisionSearchQueries };

    case "UPDATE_FILTERED_IDS_BASED_ON_SEARCH_BOX":
      return {
        ...state,
        filteredIdsBasedOnSearchBox: getFilteredIdsBasedOnSearchBox(
          state.unfilteredData,
          state.searchString
        ),
      };

    case "UPDATE_FILTERED_IDS_BASED_ON_PRECISION_SEARCH":
      return {
        ...state,
        filteredIdsBasedOnPrecisionSearch: getFilteredIdsBasedOnPrecisionSearch(
          state.unfilteredData,
          state.precisionSearchQueries
        ),
      };

    case "RESET_IDS_OF_ITEMS_IN_STAGING_AREA":
      return {
        ...state,
        idsOfItemsInStagingArea: [],
      };

    case "SET_IDS_OF_ITEMS_IN_STAGING_AREA":
      return {
        ...state,
        idsOfItemsInStagingArea: action.payload,
      };

    case "TRANSFER_STAGING_TO_CART":
      // Look at ids of items in staging
      // filter down to ids that are not in cart
      const filtered = state.idsOfItemsInStagingArea.filter(
        (d) => !state.idsOfItemsInCart.includes(d)
      );

      return {
        ...state,
        idsOfItemsInCart: [...state.idsOfItemsInCart, ...filtered],
        idsOfItemsInStagingArea: [],
      };

    case "EMPTY_CART":
      return { ...state, idsOfItemsInCart: [] };

    case "REMOVE_ITEM_FROM_CART": {
      return {
        ...state,
        idsOfItemsInCart: state.idsOfItemsInCart.filter(
          (d) => d !== action.payload
        ),
      };
    }

    case "SET_NUM_RESULTS_PER_PAGE": {
      return { ...state, numResultsPerPage: action.payload };
    }

    case "RESET_STAGING_AREA": {
      return { ...state, idsOfItemsInStagingArea: [] };
    }

    case "CREATE_CART": {
      return { ...state, cartCreated: true };
    }

    case "SET_SNACKBAR_MESSAGE":
      return { ...state, snackbarMessage: action.payload };

    case "OPEN_SNACKBAR":
      return { ...state, snackbarOpen: true };
    case "CLOSE_SNACKBAR":
      return { ...state, snackbarOpen: false };

    default:
      return state;
  }
}
